interface IProps {
  color: string
  size?: number
  viewPort?: number
  className?: string
}

export const Discount = ({ size = 24, viewPort = size, color, ...props }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    width={size}
    height={size}
    viewBox="0 0 2048 2048"
  >
    <path
      stroke={color}
      fill={color}
      strokeWidth="40"
      transform="translate(1545,16)"
      d="m0 0h18l27 2 26 4 28 7 28 10 31 15 21 13 18 13 13 11 10 9 20 20 9 11 10 13 10 15 11 19 8 16 9 21 8 24 6 25 3 19 2 24 1 354 2 20 4 16 6 15 8 14 9 11 7 8 14 11 17 10 16 7 16 5 19 4 35 3 10 3 10 7 7 8 5 9 1 1v25h-2l-2 7-8 10-10 7-14 4h-17l-29-3-25-5-26-8-21-9-18-10-17-12-13-11-6-5-7-8-10-11-10-14-9-15-10-21-7-21-5-25-2-21-1-353-2-22-5-25-6-20-6-15-8-16-9-16-10-14-9-11-14-15-10-9-16-12-21-13-16-8-20-8-26-7-18-3-11-1h-36l-23 3-21 5-20 7-16 7-17 9-12 8-12 9-10 9-8 7-11 11-11 14-11 16-9 16-8 17-7 20-5 19-3 17-2 28-1 80 65 4 157 11 18 2 9 3 10 6v2h2v2h2l7 12 3 13 14 165 24 282 16 187 1 22-2 10-6 11-12 13-840 840-11 9-12 9-17 10-19 8-17 5-24 4h-29l-19-3-19-5-20-8-16-9-14-10-11-10-8-7-129-129-7-11-3-8v-16l4-11 6-9 8-7 8-4 9-2h12l10 3 9 6 10 9 130 130 15 10 15 6 16 3h17l11-2 15-5 14-8 14-12 828-828-1-22-25-292-19-224-5-59-4-1-47-3-88-6-55-4 1 142 16 7 13 8 14 11 9 9 11 15 8 14 7 19 4 20v28l-4 20-6 16-8 16-12 16-12 12-12 9-16 9-15 6-23 5-8 1h-15l-20-3-17-5-17-8-17-12-18-18-9-13-9-17-6-18-3-17v-26l4-20 4-12 8-17 9-13 6-8h2l2-4 11-10 13-9 16-8 7-3v-147l-39-3-146-10-85-6-32-2h-8l-6 7h-2l-2 4-10 10h-2l-2 4-813 813-9 14-5 11-3 11-1 7v22l4 17 8 16 8 11 134 134 9 13 3 9v15l-4 11-6 9-8 7-8 4-9 2h-12l-10-3-11-7-136-136-9-11-9-12-9-16-7-15-7-23-3-11v-51l4-15 5-16 6-15 10-18 9-12 9-11 10-10 5-6 8-7 43-43 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 6-7 6-5 6-7 6-5 6-7 6-5 6-7 6-5 5-6 7-6 6-7 6-5 6-7 6-5 6-7 6-5 5-6 7-6 6-7 6-5 6-7 6-5 6-7 6-5 6-7 6-5 6-7 6-5 6-7 6-5 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 7-6 5-6 8-7 115-115 5-6 7-6 5-6 7-6 5-6 8-7 7-7 5-6 7-6 5-6 7-6 6-7 6-5 5-6 8-7 4-5 5-5h2l2-4h2l2-4 8-7 10-7 9-3h22l295 20 17 2v-92l3-27 5-26 8-27 8-21 13-27 13-21 12-17 8-10 9-10 7-8 16-16 11-9 10-8 17-12 24-14 25-12 28-10 28-7 25-4zm-257 683-12 2-12 6-8 7-6 10-3 8-1 6v9l3 11 5 9 7 8 10 6 10 3h15l10-3 10-6 9-10 4-8 2-8v-14l-4-12-6-9-7-7-10-5-6-2z"
    />
    <path
      stroke={color}
      fill={color}
      strokeWidth="40"
      transform="translate(782,1324)"
      d="m0 0h17l17 2 20 5 18 8 14 8 11 9 11 10 9 11 9 14 7 14 5 15 4 20 1 20-1 17-4 21-6 18-7 16-7 12-12 17-12 13-10 10-12 9-15 10-21 10-18 6-17 4-20 2h-11l-19-2-17-4-20-8-15-9-10-8-10-9-9-10-10-15-10-21-6-23-2-16v-18l3-21 5-19 8-20 10-18 8-11 7-9 12-13 8-7 13-10 16-10 19-9 18-6 20-4zm-1 82-16 4-16 8-11 8-5 4v2l-4 2-10 13-8 16-3 7-2 10-1 12 2 15 5 12 6 8 7 7 11 6 10 3 8 1h9l16-3 17-7 12-8 12-11 8-9 8-14 5-14 2-9v-19l-3-12-6-11-9-10-11-7-14-4z"
    />
    <path
      stroke={color}
      fill={color}
      strokeWidth="40"
      transform="translate(818,843)"
      d="m0 0h36l21 4 21 8 14 8 12 9 12 11 8 9 10 15 8 16 5 15 3 13 2 18v15l-3 23-6 21-6 15-7 14-12 18-13 15-11 11-17 13-13 8-21 10-22 7-24 4h-21l-21-3-20-6-17-8-15-10-10-9-12-12-10-14-10-19-5-15-4-19-1-9v-19l3-22 6-21 7-17 10-18 10-14 9-10 7-8 10-9 16-12 16-9 15-7 18-6zm14 80-13 2-15 5-14 8-13 11-9 10-8 13-6 14-3 12v21l4 13 6 11 8 8 15 8 9 2h22l17-5 17-9 10-7 10-11 10-15 6-14 3-11 1-8v-10l-3-14-7-14-5-6-10-7-9-4-7-2z"
    />
    <path
      stroke={color}
      fill={color}
      strokeWidth="40"
      transform="translate(1070,1080)"
      d="m0 0h15l10 3 9 6 8 9 5 11 1 3v15l-3 10-7 11-11 8-18 8-127 52-37 15-46 19-186 76-27 11-86 35-28 11-5 1h-15l-11-4-6-4-8-8-6-12-2-8 1-13 5-12 6-8 8-6 12-6 47-19 39-16 88-36 210-86 147-60 13-5z"
    />
    <path
      stroke={color}
      fill={color}
      strokeWidth="40"
      transform="translate(329,1655)"
      d="m0 0h12l13 4 8 6 8 9 5 11 1 6v10l-4 13-7 9-8 7-12 5-14 1-12-3-11-7-8-10-5-13v-15l4-11 6-9 8-7 8-4z"
    />
  </svg>
)
